/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PdpSharedDetail_detailValues = ReadonlyArray<{
    readonly detailKey: string | null;
    readonly browseUrl: string | null;
    readonly displayName: string | null;
    readonly displayDetails: string | null;
    readonly linkOrder: number | null;
    readonly skuId: string | null;
    readonly price?: {
        readonly convertedAmountList: ReadonlyArray<{
            readonly currency: Currency | null;
            readonly amount: number | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PdpSharedDetail_detailValues";
}>;
export type PdpSharedDetail_detailValues$data = PdpSharedDetail_detailValues;
export type PdpSharedDetail_detailValues$key = ReadonlyArray<{
    readonly " $data"?: PdpSharedDetail_detailValues$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetail_detailValues">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDetail_detailValues",
  "type": "PdpDetailValueInterface",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "detailKey",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "browseUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayDetails",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "linkOrder",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "skuId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "type": "PdpDetailVersionsValue",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "price",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "convertedAmountList",
              "storageKey": null,
              "args": null,
              "concreteType": "ConvertedAmountList",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "currency",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '6a51a0992c0be43eed8f727c11f9b820';
export default node;
